// core
import React from 'react'


// assets
import styles from './Footer.module.scss'
import Logo from "../../icons/logo.svg"
import {NavLink} from "react-router-dom";


export const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.footerInner}>
                     <img src={Logo} alt="Logo"/>
                <ul className={styles.links}>
                    <li>Solutions
                        <ul className={styles.parentHeaderLinks}>
                            <li><NavLink className={styles.link} to="/services">Services</NavLink></li>
                            <li><NavLink className={styles.link} to="/products">Products</NavLink></li>
                            {/*<li>Customers</li>*/}
                        </ul>
                    </li>
                    <li>Company
                        <ul className={styles.parentHeaderLinks}>
                            <li><NavLink className={styles.link} to="/about">About Us</NavLink></li>
                            <li><NavLink className={styles.link} to="/contactus">Contact Us</NavLink></li>
                            {/*<li><NavLink to="/contactus">Careers</NavLink></li>*/}
                        </ul></li>
                    <li>Social
                        <ul className={styles.parentHeaderLinks}>
                            <li><a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/cosmoneural">Linked In</a></li>
                            <li><a target="_blank" rel="noreferrer" href="https://www.twitter.com/cosmoneural">Twitter</a></li>
                        </ul>
                    </li>
                </ul>
            </div>

            <div className={styles.footerInner} style={{flexWrap: 'wrap-reverse'}}>
                <a href="/">Cosmoneural. © 2023. All Rights Reserved.</a>
                {/*<ul className={styles.linksEnd}>
                    <li><a href="/">Privacy Policy</a></li>
                    <li><a href="/">Data Processing Agreement</a></li>
                </ul>*/}
            </div>
        </footer>
    )
};
